import _ from 'lodash'

export default class TransactionReport {
  constructor(txCollection) {
    this.paidTransactions = txCollection.transactions
    this.refundedTransactions = txCollection.refundedTransactions
  }

  sumValue(transactions, property) {
    return _.sumBy(transactions, (tx) => parseFloat(_.get(tx, property)))
  }

  get cardTransactions() {
    return _.reject(this.paidTransactions, (transaction) => transaction.source != 'Credit Card')
  }

  get academySales() {
    return this.paidTransactions.flatMap((tx) => {
      const { percentageDiscount, amountDiscount } = tx
      const academyItems = tx.items.filter((x) => x.group == 'Academy')
      return { academyItems, percentageDiscount, amountDiscount }
    })
  }

  get cardBreakdown() {
    return _(this.cardTransactions)
      .groupBy('cardType')
      .map((transactions, cardType) => {
        const amountTotal = this.sumValue(transactions, 'receipt.amount.total')
        const feeTotal = this.sumValue(transactions, 'receipt.amount.fee')
        const properTotal = amountTotal - feeTotal
        return { cardType, total: properTotal }
      })
      .value()
  }

  get academySalesTotal() {
    let total = 0

    for (let sale of this.academySales) {
      const { percentageDiscount, amountDiscount } = sale
      const percentReduction = parseFloat(percentageDiscount) / 100
      const amountReduction = parseFloat(amountDiscount)

      let amount = _.sumBy(sale.academyItems, 'netAmount')
      if (percentReduction) amount = amount * percentReduction
      if (amountReduction) amount = amount - amountReduction

      total += amount
    }

    return total
  }

  get refundTotal() {
    return this.sumValue(this.refundedTransactions, 'receipt.amount.total')
  }

  get taxTotal() {
    return this.sumValue(this.paidTransactions, 'receipt.amount.tax')
  }
}
